import { createUseStyles } from "react-jss";
import type { VetBoatsTheme } from "../../theme";

type Kind = "error" | "success" | "info";

const useStyles = createUseStyles((theme: VetBoatsTheme) => ({
  notice: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between",
    gap: 12,
    padding: "10px 14px",
    borderRadius: 6,
    border: "1px solid",
    margin: "12px 0",
    whiteSpace: "pre-line",
  },
  error: {
    color: theme.color.danger,
    background: theme.color.dangerBg,
    borderColor: `${theme.color.danger}40`,
  },
  success: {
    color: theme.color.success,
    background: theme.color.successBg,
    borderColor: `${theme.color.success}40`,
  },
  info: {
    color: theme.color.info,
    background: theme.color.infoBg,
    borderColor: `${theme.color.info}40`,
  },
  dismiss: {
    border: "none",
    background: "transparent",
    color: "inherit",
    cursor: "pointer",
    fontSize: 18,
    lineHeight: 1,
    padding: 0,
  },
}));

interface NoticeProps {
  kind: Kind;
  children: string;
  onDismiss?: () => void;
}

export const Notice = ({ kind, children, onDismiss }: NoticeProps) => {
  const classes = useStyles();
  return (
    <div
      className={`${classes.notice} ${classes[kind]}`}
      role={kind === "error" ? "alert" : "status"}
    >
      <span>{children}</span>
      {onDismiss && (
        <button
          type="button"
          className={classes.dismiss}
          onClick={onDismiss}
          aria-label="Dismiss"
        >
          ×
        </button>
      )}
    </div>
  );
};
